import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import InvestmentSuccess from "./InvestmentSuccess";
import InvestmentOverviewData from "./InvestmentOverviewData";
import InvestmentTanganyData from "./InvestmentTanganyData";

import { selectInvestmentStepData } from "store/user/investment/selectors";
import { setInvestmentStepData } from "store/user/investment/actions";
import { useSideModalScrollToTop } from "hooks";

export const RenderOverviewStep = ({
    investmentStepData,
    setInvestmentStepData,
    hideInvestmentModal,
    setInvestmentKycModalFlag,
    backButton,
    hitBack,
    openInvestment,
    backSlideEffect = "",
    setBackSlideEffect,
    isGfkOnboardingProduct,
    isEwPgInvestmentProcess,
    productCatalog,
    productType,
}) => {
    useEffect(() => {
        if (backButton) {
            const step = investmentStepData.investmentData.overviewData.step;
            hitBack();
            if (step === "investmentOverviewData") {
                setInvestmentStepData({ investmentData: { step: "investmentCalculationStep" } });
            } else {
                hideInvestmentModal();
            }
        }
    }, [backButton]);

    function renderOverviewStep() {
        switch (investmentStepData.investmentData.overviewData.step) {
            case "investmentOverviewData":
                return (
                    <InvestmentOverviewData
                        isGfkOnboardingProduct={isGfkOnboardingProduct}
                        isEwPgInvestmentProcess={isEwPgInvestmentProcess}
                        backSlideEffect={backSlideEffect}
                        setBackSlideEffect={setBackSlideEffect}
                        setInvestmentStepData={setInvestmentStepData}
                        investmentStepData={investmentStepData}
                        productCatalog={productCatalog}
                        productType={productType}
                    />
                );
            case "investmentTanganyData":
                return (
                    <InvestmentTanganyData
                        backSlideEffect={backSlideEffect}
                        setBackSlideEffect={setBackSlideEffect}
                        setInvestmentStepData={setInvestmentStepData}
                    />
                );
            case "investmentSuccess":
                return (
                    <InvestmentSuccess
                        backSlideEffect={backSlideEffect}
                        setInvestmentKycModalFlag={setInvestmentKycModalFlag}
                        hideInvestmentModal={hideInvestmentModal}
                        openInvestment={openInvestment}
                    />
                );
            default:
                return (
                    <InvestmentOverviewData
                        setInvestmentStepData={setInvestmentStepData}
                        investmentStepData={investmentStepData}
                    />
                );
        }
    }
    return renderOverviewStep();
};

const InvestmentOverviewStep = ({
    className = "",
    investmentStepData,
    setInvestmentStepData,
    hideInvestmentModal,
    setInvestmentKycModalFlag,
    backButton,
    hitBack,
    openInvestment,
    backSlideEffect = "",
    setBackSlideEffect,
    isGfkOnboardingProduct,
    isEwPgInvestmentProcess,
    productCatalog,
    productType,
}) => {
    useSideModalScrollToTop();

    return (
        <div className={`${className} investment-success-step mt-6`}>
            <RenderOverviewStep
                backButton={backButton}
                hitBack={hitBack}
                setInvestmentStepData={setInvestmentStepData}
                investmentStepData={investmentStepData}
                hideInvestmentModal={hideInvestmentModal}
                setInvestmentKycModalFlag={setInvestmentKycModalFlag}
                openInvestment={openInvestment}
                backSlideEffect={backSlideEffect}
                setBackSlideEffect={setBackSlideEffect}
                isGfkOnboardingProduct={isGfkOnboardingProduct}
                isEwPgInvestmentProcess={isEwPgInvestmentProcess}
                productCatalog={productCatalog}
                productType={productType}
            />
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    investmentStepData: selectInvestmentStepData,
});

const mapDispatchToProps = (dispatch) => ({
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentOverviewStep);
